import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { useWhatsApp } from '../context/WhatsAppProvider'

type WhatsAppLinkProps = {
  className?: string
  children: ReactNode
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'className'>

const WhatsAppLink = ({
  className,
  children,
  type = 'button',
  onClick,
  ...props
}: WhatsAppLinkProps) => {
  const { openWhatsApp } = useWhatsApp()

  return (
    <button
      type={type}
      className={className}
      onClick={(e) => {
        onClick?.(e)
        openWhatsApp()
      }}
      {...props}
    >
      {children}
    </button>
  )
}

export default WhatsAppLink
